import superagent from '@ott/superagent';

import { ServerError, ServerStation, Station, TargetType } from '../types';
import extractError from './extractError';

type Success = { data: ServerStation };
type Error = { error: ServerError };

const stationAdapter = (response: Success['data']): Station => {
  return {
    countryName: response.countryName,
    districtName: response.districtName || null,
    geoPointId: response.geopoint.id,
    geoPointName: response.geopoint.name,
    geoPointTranslit: response.geopoint.trnslt,
    name: response.name,
    regionName: response.regionName || null,
    id: response.id,
    targetType: TargetType.Station,
    translit: response.trnslt,
    typeName: response.typeName,
  };
};

const fetchStationById = async (id: string) => {
  try {
    const response: Station = await superagent
      .get(`/_bus/geo/stations/${id}`)
      .then((res: Response) => res.body)
      .then((res: Success | Error) => extractError<Success, Error>(res))
      .then(stationAdapter);

    return response;
  } catch {
    return null;
  }
};

export default fetchStationById;
